'use client';
import { getThemeClass } from '@/helpers/theme';
import { cn } from '@/lib/utils';
import { SectionItem } from '@/types/product_page/productType';
import React from 'react';

const FeaturesList = ({ data }: { data: SectionItem }) => {
  const theme = data?.theme || 'dark';

  return (
    <div
      className={`w-full py-8 md:py-14 px-4 ${getThemeClass(theme, 'background')}`}
      id={data.heading}
    >
      <h1
        className={`text-3xl lg:text-4.5xl font-bold text-center mb-8 ${getThemeClass(theme, 'heading')}`}
      >
        {data.heading}
      </h1>
      <div
        className={`max-w-7xl w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-6`}
      >
        {data.features &&
          data.features.map(({ title, content }, index) => (
            <div
              key={index}
              className={cn(
                'flex flex-col gap-2 p-8 rounded-xl lg:min-h-52',
                theme === 'light' ? 'bg-off-white' : 'bg-gray-dark'
              )}
            >
              <h3
                className={`text-lg md:text-[26px] font-bold text-inherit ${getThemeClass(theme, 'heading')}`}
              >
                {title}
              </h3>
              <p
                className={`text-[16px] font-medium font-proxima_font opacity-80 text-inherit ${getThemeClass(theme, 'text')}`}
              >
                {content}
              </p>
            </div>
          ))}
      </div>
    </div>
  );
};

export default FeaturesList;
